import "./style.scss";
import Glide from '@glidejs/glide'

var aPayCols1 = document.querySelector('#amazon_customer_details .col-1');
var aPayCols2 = document.querySelector('#amazon_customer_details .col-2');

if (aPayCols1) {
  aPayCols1.classList.remove('col-1');
  aPayCols2.classList.remove('col-2');
  document.querySelector('#amazon_customer_details').classList.add('col-lg-7');
};

function isMobile() {
	var resultMobile = false;
	if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
		resultMobile = true;
	}
	return resultMobile;
}

function isTablet(){
	const userAgent = navigator.userAgent.toLowerCase();
	const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent)
	return isTablet;
}

function fixedHeader() {
  let getHeaderDesktop = document.getElementById("header-desktop");
  const body = document.body;
  const scrollUp = "scroll-up";
  const scrollDown = "scroll-down";
  var scrollPos = 0;

  // window.addEventListener("scroll", () => {
  //   const currentScroll = window.pageYOffset;
  //   if (currentScroll <= 0) {
  //     body.classList.remove(scrollUp);

  //     getHeaderDesktop.childNodes[5].classList.remove(scrollDown);
  //     getHeaderDesktop.childNodes[5].classList.add(scrollUp);
  //     return;
  //   }

  //   if ((body.getBoundingClientRect()).top > scrollPos && body.classList.contains(scrollDown)){
  //     body.classList.remove(scrollDown);
  //     body.classList.add(scrollUp);
  //   }else if( (body.getBoundingClientRect()).top < scrollPos && !body.classList.contains(scrollDown)){
  //     body.classList.remove(scrollUp);
  //     body.classList.add(scrollDown);
  //     getHeaderDesktop.childNodes[5].classList.add(scrollDown);
  //     getHeaderDesktop.childNodes[5].classList.remove(scrollUp);
  //   }
  //   scrollPos = (body.getBoundingClientRect()).top;
  // });
}

function removeURLParameter(url, parameter) {
  var urlparts = url.split('?');
  if (urlparts.length >= 2) {
    var prefix = encodeURIComponent(parameter) + '=';
    var pars = urlparts[1].split(/[&;]/g);
    for (var i = pars.length; i-- > 0;) {
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }
    return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
  }
  return url;
}

window.addEventListener("DOMContentLoaded", function (e) {
  let detectPage = document.getElementById("detect-page").value;

  if(detectPage !== 'pagamento' && !isMobile()){
    fixedHeader();

    let firstElement = document.querySelector(".first-element");
    firstElement.style.marginTop = (document.getElementById("header-desktop").offsetHeight + 50) + 'px';
  }

  if(detectPage == 'singolo-articolo'){

    if(document.getElementsByClassName("article_cross_sells")[0]){
      var glideHero = new Glide('.article_cross_sells', {
        type: 'slider',
        aimationDuration: 2000,
        startAt: 0,
        perView: 3,
        breakpoints: {
          800: {
              perView: 3
          },
          500: {
              perView: 1
          },
        },
        focusAt: 0,
        gap: 10,
        autoplay: false,
        keyboard: true,
        bound: true,
        peek: { before: 60, after: 60 }
      });

      glideHero.mount();
    }

    if(document.getElementsByClassName("intermediate_cross_sells")[0]){
      var glideArticle = new Glide('.intermediate_cross_sells', {
        type: 'slider',
        aimationDuration: 2000,
        startAt: 0,
        perView: 3,
        breakpoints: {
          800: {
              perView: 3
          },
          500: {
              perView: 1
          },
        },
        focusAt: 0,
        gap: 10,
        autoplay: false,
        keyboard: true,
        bound: true,
        peek: { before: 60, after: 60 }
      });

      glideArticle.mount();
    }
  }

  if(detectPage == 'cart'){
    if(document.getElementsByClassName("cart_cross_sells")[0]){
      var glideHero = new Glide('.cart_cross_sells', {
        type: 'slider',
        aimationDuration: 2000,
        startAt: 0,
        perView: 3,
        breakpoints: {
          800: {
              perView: 3
          },
          500: {
              perView: 1
          },
        },
        focusAt: 0,
        gap: 10,
        autoplay: false,
        keyboard: true,
        bound: true,
        peek: { before: 60, after: 60 }
      });

      glideHero.mount();
    }
  }

  if(detectPage == 'black-friday'){
    let allList = document.querySelectorAll(".black-friday_row-filter__item");
    for(let i = 0; i < allList.length; i++){
      allList[i].addEventListener("click", function(e){
        let currentItem = this.getAttribute("data-item");
        let allContent = document.querySelectorAll(".black-friday_row-content");
        for(let k = 0; k < allContent.length; k++){
          let currentContent = allContent[k].getAttribute("data-content");
          if(currentContent == currentItem){
            allContent[k].classList.add("show");
            allContent[k].classList.remove("hide");
          }else{
            allContent[k].classList.remove("show");
            allContent[k].classList.add("hide");
          }
        }
      });
    }
  }

  if(detectPage == 'artigiani'){
    const stateParam = new URL(window.location.href).searchParams.get('state');
    const regionParam = new URL(window.location.href).searchParams.get('region');
    let selectNazioni = document.querySelector(".select_nazioni");
    let selectPaesi = document.querySelectorAll(".select_paesi");

    if(stateParam !== null){
      let idNation = null;
      for(let i = 0; i < selectNazioni.length; i++){
        if(selectNazioni[i].value === stateParam){
          idNation = selectNazioni[i].getAttribute("data-id");
          selectNazioni[i].selected = 'selected';
        }
      }

      for(let k = 0; k < selectPaesi.length; k++){
        if(selectPaesi[k].getAttribute("data-id") === idNation){
          selectPaesi[k].style.display = 'flex';
          for(let h = 0; h < selectPaesi[k].length; h++){
            if(selectPaesi[k][h].value === regionParam){
              selectPaesi[k][h].selected = 'selected';
            }
          }

          selectPaesi[k].addEventListener('change',function(e){
            let submitFilter = document.getElementById("submit_filter_paesi");
            let urlGetParams = '?state=' + stateParam + '&region=' + selectPaesi[k].value + '';
            submitFilter.href = urlGetParams;
          });
        }
      }

      selectNazioni.addEventListener('change',function(e){
        e.preventDefault();
        let self = this;
        for(let i = 0; i < selectPaesi.length; i++){
          selectPaesi[i].style.display = 'none';
          if(selectPaesi[i].getAttribute("data-id") == this.options[this.selectedIndex].getAttribute("data-id")){
            if(selectPaesi[i].options.length < 0){
              return;
            }else if(selectPaesi[i].options.length == 1){
              selectPaesi[i].style.display = 'flex';
              let submitFilter = document.getElementById("submit_filter_paesi");
              let urlGetParams = '?state=' + self.options[self.selectedIndex].value + '&region=' + selectPaesi[0].value + '';
              submitFilter.href = urlGetParams;
            }else{
              selectPaesi[i].style.display = 'flex';
              selectPaesi[i].addEventListener('change',function(e){
                let submitFilter = document.getElementById("submit_filter_paesi");
                let urlGetParams = '?state=' + self.options[self.selectedIndex].value + '&region=' + selectPaesi[i].value + '';
                submitFilter.href = urlGetParams;
              });
            }
          }
        }
      });
    }else{
      selectNazioni.addEventListener('change',function(e){
        e.preventDefault();
        let self = this;
        for(let i = 0; i < selectPaesi.length; i++){
          selectPaesi[i].style.display = 'none';
          if(selectPaesi[i].getAttribute("data-id") == this.options[this.selectedIndex].getAttribute("data-id")){
            if(selectPaesi[i].options.length < 0){
              return;
            }else if(selectPaesi[i].options.length == 1){
              selectPaesi[i].style.display = 'flex';
              let submitFilter = document.getElementById("submit_filter_paesi");
              removeURLParameter(window.location.href, 'state');
              removeURLParameter(window.location.href, 'region');
              let urlGetParams = '?state=' + self.options[self.selectedIndex].value + '&region=' + selectPaesi[i].value + '';
              submitFilter.href = urlGetParams;
            }else{
              selectPaesi[i].style.display = 'flex';
              selectPaesi[i].addEventListener('change',function(e){
                let submitFilter = document.getElementById("submit_filter_paesi");
                let urlGetParams = '?state=' + self.options[self.selectedIndex].value + '&region=' + selectPaesi[i].value + '';
                submitFilter.href = urlGetParams;
              });
            }
          }
        }
      });
    }
  }

  if(detectPage == 'prodotto'){
    let productPageArrows = document.querySelectorAll(".product_description__active-cta");
    for(var h = 0; h < productPageArrows.length; h++){
      productPageArrows[h].addEventListener("click", function(e){

        if(e.target.classList.contains('product_description__content') || e.target.closest('.product_description__content')){
          return;
        }

        e.preventDefault();

        if(this.childNodes[1].childNodes[3].classList.contains('is-closed')){
          this.childNodes[1].childNodes[3].classList.remove("is-closed");
          this.childNodes[1].childNodes[3].classList.add("is-opened");
        }else{
          this.childNodes[1].childNodes[3].classList.add("is-closed");
          this.childNodes[1].childNodes[3].classList.remove("is-opened");
        }

        if(this.childNodes[3].classList.contains("is-closed")){
          this.childNodes[3].classList.remove("is-closed");
          this.childNodes[3].classList.add("is-opened");
        }else{
          this.childNodes[3].classList.add("is-closed");
          this.childNodes[3].classList.remove("is-opened");
        }
      })
    }
  }

  // if(document.getElementsByClassName("article_cross_sells")[0]){
  //   var glideHero = new Glide('.article_cross_sells', {
  //     type: 'slider',
  //     aimationDuration: 2000,
  //     startAt: 0,
  //     perView: 3,
  //     breakpoints: {
  //       800: {
  //           perView: 3
  //       },
  //       500: {
  //           perView: 1
  //       },
  //     },
  //     focusAt: 0,
  //     gap: 10,
  //     autoplay: false,
  //     keyboard: true,
  //     bound: true,
  //     peek: { before: 60, after: 60 }
  //   });

  //   glideHero.mount();
  // }

  if(isMobile()){
    let filterMobileCat = document.getElementById("category_filter_mobile");
    if(filterMobileCat){
      filterMobileCat.addEventListener("click", function(e){
        if(document.getElementById("sidebar_filter_category").classList.contains("is-closed")){
          document.getElementById("sidebar_filter_category").classList.remove("is-closed");
          document.getElementById("sidebar_filter_category").classList.add("is-opened");
        }else{
          document.getElementById("sidebar_filter_category").classList.add("is-closed");
          document.getElementById("sidebar_filter_category").classList.remove("is-opened");
        }
      });
    }
  }
});


if(isMobile()){
  let hamburgerMobile = document.getElementById("mobile_hamburger");
  hamburgerMobile.addEventListener("click", function(e){
    this.classList.remove("first_load");
    if(this.classList.contains("opened")){
      this.classList.add("closed");
      this.classList.remove("opened");
    }else{
      this.classList.remove("closed");
      this.classList.add("opened");
    }

    if(this.parentNode.parentNode.children[1].classList.contains("opened")){
      this.parentNode.parentNode.children[1].classList.add("closed");
      this.parentNode.parentNode.children[1].classList.remove("opened");
      // document.body.classList.remove("body-no-scroll");
    }else{
      this.parentNode.parentNode.children[1].classList.remove("closed");
      this.parentNode.parentNode.children[1].classList.add("opened");
      // document.body.classList.add("body-no-scroll");
    }
  });

  let allItemMenu = document.querySelectorAll(".header_mobile__primary-menu--item");
  for(let i = 0; i < allItemMenu.length; i++){
    if(allItemMenu[i].getAttribute("data-children") === 'has_children'){
      allItemMenu[i].addEventListener("click", function(e){
        if(this.children[0] === e.target){
          this.classList.remove("is-closed");
          this.classList.add("is-opened");
        }else{
          allItemMenu[i].childNodes[3].childNodes[1].lastElementChild.addEventListener("click", function(evento){
            allItemMenu[i].classList.remove("is-opened");
            allItemMenu[i].classList.add("is-closed");
          });
        }
      })
    }
  }
}
